window.sortableFormatter = function(value, row) {
    if (row.id) {
        return '<i class="fad fa-sort fa-2x sortable" data-id="' + row.id + '"></i>';
    }
};
